import React from 'react';
import PropTypes from 'prop-types';

import { getCurrencySymbol } from '../../../helpers/ProductPrice';
import Button from '../../common/Button';
import styles from './style.module.scss';

const BundleActions = (props) => {
  const {
    sectionsNotReady,
    addBuilderProductsToCart,
    totalPrice,
    builderDiscount,
    currencyCode,
  } = props;

  const {
    final,
    original,
  } = totalPrice;

  return (
    <>
      {!sectionsNotReady && (
        <p className={styles.price}>
          <span className={styles.priceFinal}>
            {final && (`${getCurrencySymbol(currencyCode)}${final}`)}
          </span>
          <span className={styles.priceOriginal}>
            <s>{original && (`${getCurrencySymbol(currencyCode)}${original}`)}</s>
            {(builderDiscount !== 0 && builderDiscount !== '0') && (
              <span>{`SAVE ${builderDiscount}%`}</span>
            )}
          </span>
        </p>
      )}
      <Button
        label="Add to basket"
        buttonStyle="AddtoBasket primary"
        trigger={() => { addBuilderProductsToCart(); }}
        disabled={sectionsNotReady}
      />
    </>
  );
};

BundleActions.propTypes = {
  sectionsNotReady: PropTypes.bool,
  addBuilderProductsToCart: PropTypes.func,
  totalPrice: PropTypes.shape({
    final: PropTypes.number,
    original: PropTypes.number,
  }),
  builderDiscount: PropTypes.string,
  currencyCode: PropTypes.string,
};

BundleActions.defaultProps = {
  sectionsNotReady: false,
  addBuilderProductsToCart: () => {},
  totalPrice: {
    final: 0,
    original: 0,
  },
  builderDiscount: '',
  currencyCode: 'GBP',
};

export default BundleActions;
